import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Rocket, HeartPulse, Globe2, Users } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function About() {
    const { t } = useTranslation();
    return (
        <div className="bg-white" data-testid="about-page">
            <Navbar />
            <main className="pt-28">
                <section className="max-w-7xl mx-auto px-6 md:px-12 py-16">
                    <div className="text-xs font-mono tracking-[0.22em] text-[var(--medx-red)] mb-4">{t("about.eyebrow")}</div>
                    <h1 className="font-display text-5xl md:text-7xl font-bold tracking-tighter max-w-4xl">
                        {t("about.titlePre")}<span className="brand-gradient-text">{t("about.titleAccent")}</span>{t("about.titlePost")}
                    </h1>
                    <p className="text-lg text-gray-600 max-w-2xl mt-6 leading-relaxed">
                        {t("about.intro")}
                    </p>
                </section>

                <section className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-8 pb-12">
                    <div className="rounded-3xl overflow-hidden">
                        <img src="https://customer-assets-gfyr7b9c.emergentagent.net/job_medx-dashboard-demo/artifacts/brgldmgz_WhatsApp%20Image%202026-07-15%20at%205.44.21%20PM.jpeg" alt="A patient at the Medx AI Health & Wellness Kiosk" className="w-full h-full object-cover aspect-[5/4] bg-white" />
                    </div>
                    <div className="space-y-6">
                        <div className="card-soft p-6">
                            <Rocket className="w-6 h-6 text-[var(--medx-orange)] mb-3" />
                            <div className="font-display text-2xl font-semibold mb-2">{t("about.missionTitle")}</div>
                            <p className="text-gray-600 leading-relaxed">
                                {t("about.mission")}
                            </p>
                        </div>
                        <div className="card-soft p-6">
                            <HeartPulse className="w-6 h-6 text-[var(--medx-red)] mb-3" />
                            <div className="font-display text-2xl font-semibold mb-2">{t("about.visionTitle")}</div>
                            <p className="text-gray-600 leading-relaxed">
                                {t("about.vision")}
                            </p>
                        </div>
                    </div>
                </section>

                <section className="bg-[var(--medx-cream)]">
                    <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-3 gap-8">
                        {[
                            { icon: Globe2, k: t("about.reachTitle"), v: t("about.reach") },
                            { icon: Users, k: t("about.peopleTitle"), v: t("about.people") },
                            { icon: Rocket, k: t("about.backedTitle"), v: t("about.backed") },
                        ].map((b, i) => {
                            const Icon = b.icon;
                            return (
                                <div key={i} className="bg-white rounded-2xl p-6 border border-orange-100">
                                    <Icon className="w-7 h-7 text-[var(--medx-red)] mb-3" />
                                    <div className="font-display text-xl font-semibold mb-1">{b.k}</div>
                                    <div className="text-gray-600 text-sm leading-relaxed">{b.v}</div>
                                </div>
                            );
                        })}
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
